interface UpdateAreaPoint {
    pointLocalId: string;
    area: Area;
    lngLat: mapboxgl.LngLat;
}

export default function updateAreaPoint({
    area,
    pointLocalId,
    lngLat,
}: UpdateAreaPoint): Area | undefined {
    if (!area.isGeometryLoaded || !area.isGeometryEditable) return undefined;

    if (!area.points[pointLocalId]) return area;

    const point: AreaPoint = {
        ...area.points[pointLocalId],
        geometry: {
            type: 'Point',
            coordinates: lngLat.toArray(),
        },
    };

    const updatedArea = {
        ...area,
        points: {
            ...area.points,
            [pointLocalId]: {
                ...area.points[pointLocalId],
                ...point,
            },
        },
    };

    return updatedArea;
}
